import { FC } from "react";
import { InfoBanner, RouterLink } from "components";
import { TEXTS } from "../../constants";
import { PROFILE_TEMPLATE_PAGES } from "constants/pages";

interface IMovedToTemplatesNotice {
  /** Per-tab wording describing what moved (must mention the Default template). */
  message: string;
}

const MovedToTemplatesNotice: FC<IMovedToTemplatesNotice> = ({ message }) => (
  <InfoBanner
    fontSize="16px"
    fontWeight="400"
    showIcon={false}
    description={
      <>
        {message}{" "}
        <RouterLink to={PROFILE_TEMPLATE_PAGES.LIST} className="underline">
          {TEXTS.movedToTemplates.linkText}
        </RouterLink>
      </>
    }
  />
);

export default MovedToTemplatesNotice;
